import { Injectable } from "@angular/core";
import { IObjectKey, IRolePermission } from "@nova/common-interfaces";
import { FUNCTION_NAME } from "@rfm/shared-interfaces";
import { CommonService } from "../../common/common.service.mjs";

@Injectable({ providedIn: "root" })
export class PermissionService extends CommonService<
  IRolePermission,
  IObjectKey
> {
  public override deleteFunctionName: FUNCTION_NAME =
  FUNCTION_NAME.PLATFORM_PERMISSION_REMOVE;
  
  // #region Properties (6)

  public override getAllFunctionName: FUNCTION_NAME =
    FUNCTION_NAME.PLATFORM_PERMISSION_GETALL;
  public override getFunctionName: FUNCTION_NAME =
    FUNCTION_NAME.PLATFORM_PERMISSION_GET;
  public override getKeysFunctionName: FUNCTION_NAME =
    FUNCTION_NAME.PLATFORM_PERMISSION_GETKEYS;
  public override insertFunctionName: FUNCTION_NAME =
    FUNCTION_NAME.PLATFORM_PERMISSION_INSERT;
  public override mergeFunctionName: FUNCTION_NAME =
    FUNCTION_NAME.PLATFORM_PERMISSION_MERGE;
  public override updateFunctionName: FUNCTION_NAME =
    FUNCTION_NAME.PLATFORM_PERMISSION_UPDATE;

  // #endregion Properties (6)

  // #region Public Methods (1)

  public async refresh(): Promise<boolean> {
    return Promise.resolve(true);
  }

  // #endregion Public Methods (1)
}
